import { Button, Modal, Space } from "antd";
import { useState } from "react";
import { SVGicon } from "../../SVGicon/SVGicon";

export function StyledModalSHB() {
  const [basicModalOpen, setBasicModalOpen] = useState(false);
  const [noCloseModal, setNoCloseModal] = useState(false);
  const [staticBackdropModal, setStaticBackdropModal] = useState(false);
  const [customWidthModal, setCustomWidthModal] = useState(false);

  const handleBasicClose = () => {
    setBasicModalOpen(false);
  };

  const handleNoCloseClose = () => {
    setNoCloseModal(false);
  };

  const handleStaticBackdropClose = () => {
    setStaticBackdropModal(false);
  };

  const handleCustomWidthClose = () => {
    setCustomWidthModal(false);
  };

  const CustomModal = () => {
    return (
      <Modal
        title="Basic Modal"
        open={basicModalOpen}
        closeIcon={SVGicon.mtpIconClose}
        wrapClassName="mtp-modal"
        onCancel={handleBasicClose}
        footer={""}
        centered
      >
        Custom Modal
      </Modal>
    );
  };

  const CustomModalNoClose = () => {
    return (
      <Modal
        title="Basic Modal without close button"
        open={noCloseModal}
        wrapClassName="mtp-modal no-close"
        onCancel={handleNoCloseClose}
        footer={""}
        centered
      >
        Custom Modal
      </Modal>
    );
  };

  const NoCloseOnClickOutside = () => {
    return (
      <Modal
        title="Doesn't close on outside click"
        open={staticBackdropModal}
        closeIcon={SVGicon.mtpIconClose}
        wrapClassName="mtp-modal"
        onCancel={handleStaticBackdropClose}
        footer={""}
        maskClosable={false}
        centered
      >
        Custom Modal
      </Modal>
    );
  };

  const CustomWidth = () => {
    return (
      <Modal
        title="Custom Width"
        open={customWidthModal}
        closeIcon={SVGicon.mtpIconClose}
        wrapClassName="mtp-modal"
        width={420}
        footer={""}
        onCancel={handleCustomWidthClose}
        centered
      >
        Custom Modal
      </Modal>
    );
  };

  return (
    <>
      <Space size={14}>
        <Button className="CustomButton" type="prime-outlined" onClick={() => setBasicModalOpen(true)}>
          Modal with Close Buttons
        </Button>

        <Button className="CustomButton" type="prime-outlined" onClick={() => setNoCloseModal(true)}>
          Modal without Close Buttons
        </Button>

        <Button className="CustomButton" type="prime-outlined" onClick={() => setStaticBackdropModal(true)}>
          Static Backdrop Modal
        </Button>

        <Button className="CustomButton" type="prime-outlined" onClick={() => setCustomWidthModal(true)}>
          Custom Width Modal
        </Button>
      </Space>

      <CustomModal />
      <CustomModalNoClose />
      <NoCloseOnClickOutside />
      <CustomWidth />
    </>
  );
}
